export const SELECTOR = 'uClSrc';

// The given environment’s Cloudinary URL will be prepended to whatever’s
// passed to the attribute. Based on implementation of `ng-src`:
// https://github.com/angular/angular.js/blob/9f68b0e29dfab351736c622119e6f07e51bd71ee/src/ng/directive/attrs.js#L394
export function UCloudinarySrcDirective(updEnvironment) {
  'ngInject';
  return {
    priority: 99, // it needs to run after the attributes are interpolated
    link: link(updEnvironment),
  };
}

function link(env) {
  return function(scope, element, attr) {
    attr.$observe(SELECTOR, function(value) {
      if (!value) {
        return;
      }

      attr.$set('src', getCloudinaryUrl(value));
    });
  };

  function getCloudinaryUrl(value) {
    return `${env.endpoints.cloudinary}/${value}`;
  }
}
